export const ID_LINEUP = 'ID_LINEUP';
export const LINEUP_TYPE = 'LINEUP_TYPE';
export const LINEUP_TEMPLATE = 'LINEUP_TEMPLATE';
export const SEARCH_INPUT_TEXT = 'SEARCH_INPUT_TEXT';
export const PARTICIPANT_PITCH = 'PARTICIPANT_PITCH';
export const PITCH_LINEUP_TEMPLATE = 'PITCH_LINEUP_TEMPLATE';
export const PARTICIPANT_CUSTOM_NAME = 'PARTICIPANT_CUSTOM_NAME';
export const PARTICIPANT_CUSTOM_TEXT = 'PARTICIPANT_CUSTOM_TEXT';



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/constants.js
 **/